// @flow
import types from "./types";
import type {ServiceConfig} from "./reducers";
import {prepareServicePolygon} from "./utils";

const updateServiceConfigurationsData = (serviceConfigData: ServiceConfig) => ({
    type: types.SERVICE_DATA_UPDATE,
    payload: serviceConfigData
});

const setServicePolygon = (data: Object) => ({
    type: types.SERVICE_POLYGON_SET,
    payload: prepareServicePolygon(data),
});

const setOriginTerminalOptions = (data: Object) => {
    return {
        type: types.SERVICE_ORIGIN_TERMINALS_SET,
        payload: data.locations,
    };
};

const setDestTerminalOptions = (data: Object) => {
    return {
        type: types.SERVICE_DEST_TERMINALS_SET,
        payload: data.locations,
    };
};

export default {
    updateServiceConfigurationsData,
    setServicePolygon,
    setOriginTerminalOptions,
    setDestTerminalOptions,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/actions.js